//@flow
import React from 'react';
import {useLocation} from 'react-router-dom';
import {Hidden} from '@material-ui/core';

import type {
  Store,
  User,
  ResellerInformation,
  StoreTier,
} from '../../../entities';
import {PAGES} from '../config';
import SidebarContainer from './SidebarContainer';
import SidebarHeader from './SidebarHeader';
import SidebarFooter from './SidebarFooter';
import SidebarSection from './SidebarSection';
import SidebarItem from './SidebarItem';
import SidebarContent from './SidebarContent';

type Props = {
  drawerWidth: number,
  store?: Store,
  user?: User,
  resellerInformation?: ResellerInformation,
  isFetchingResellerInformation?: boolean,
  storePreviousTier?: StoreTier,
  storeTier?: StoreTier,
};

export default function SideBar(props: Props) {
  const location = useLocation();

  if (
    location.pathname === '/login' ||
    location.pathname === '/login/' ||
    location.pathname.startsWith('/on-boarding')
  ) {
    return null;
  }

  return (
    <Hidden smDown>
      <SidebarContainer>
        <SidebarHeader />
        <SidebarContent>
          {PAGES.map(section => {
            return (
              <SidebarSection key={section.id} header={section.header}>
                {section.items.map(item => (
                  <SidebarItem key={item.id} item={item} />
                ))}
              </SidebarSection>
            );
          })}
          <SidebarFooter />
        </SidebarContent>
      </SidebarContainer>
    </Hidden>
  );
}
